import { Injectable } from '@angular/core';
import { HttpHeaders, HttpParams, HttpRequest } from '@angular/common/http';
import { Observable, Subject, Subscription } from 'rxjs';

interface RequestCacheEntry {
  observable: Observable<any>;
  subject: Subject<any>;
  subscription?: Subscription,
  url?: string
}

@Injectable({
  providedIn: 'root',
})
export class RequestCacheService {
  private cache = new Map<string, RequestCacheEntry>();

  get(req: HttpRequest<any>, url: string): RequestCacheEntry | undefined {
    return this.cache.get(this.getKey(req, url));
  }

  set(req: HttpRequest<any>, entry: RequestCacheEntry): void {
    this.cache.set(this.getKey(req, entry.url || ''), entry);
  }

  delete(req: HttpRequest<any>, url: string): void {
    const entry = this.cache.get(this.getKey(req, url));
    if (entry) {
      entry.subscription?.unsubscribe();
      this.cache.delete(this.getKey(req, url));
    }
  }

  normalizeHeaders(headers: HttpHeaders): string {
    let normalizedHeaders: {[key: string]: any} = {};
    headers.keys().forEach(key => {
      normalizedHeaders[key] = headers.getAll(key);
    });
    return JSON.stringify(normalizedHeaders);
  }

  normalizeParams(params: HttpParams): string {
    let normalizedParams: {[key: string]: any} = {};
    params.keys().forEach(key => {
      normalizedParams[key] = params.getAll(key);
    });
    return JSON.stringify(normalizedParams);
  }

  getKey(req: HttpRequest<any>, url: string): string {
    let headers = req.headers;
    let params = req.params;
    let method = req.method;
    let headersStr = this.normalizeHeaders(headers);
    let paramsStr = this.normalizeParams(params);

    return `${url}:${method}:${headersStr}:${paramsStr}`;
  }
}
